import React from 'react';

/**
 * Button to open the saved searches modal.
 * Shows a badge with the count of saved searches if any exist.
 */
function SavedSearchesButton({ onClick, count = 0, isSubscriber = false }) {
  const tooltip = isSubscriber 
    ? `My Searches${count > 0 ? ` (${count})` : ''}`
    : "Pro feature: Save & manage searches. Click \"Get Pro\" to upgrade.";
  
  return (
    <button
      className={`saved-searches-button ${count > 0 ? 'has-searches' : ''}`}
      onClick={onClick}
      title={tooltip}
      aria-label={tooltip}
    >
      {/* Bookmark/folder icon */}
      <svg 
        className="saved-searches-button__icon" 
        width="18" 
        height="18" 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke="currentColor" 
        strokeWidth="2"
      >
        <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z" />
      </svg>
      <span className="saved-searches-button__label">My Searches</span>
      {count > 0 && (
        <span className="saved-searches-button__badge">{count}</span>
      )}
    </button>
  );
}

export default SavedSearchesButton;
